// extracted by mini-css-extract-plugin
export default {"root":"pending_contracts_root__ywsnS","searchInputContainer":"pending_contracts_searchInputContainer__cI7t2"};